{
  "adultShort": "{n} ерс",
  "childShort": "{n} бала",
  "infantShort": "{n} сәби",
  "youthShort": "{n} жас"
}
